import slidingWindowProblems from './ExampleProblems/SlidingWindowExamples';
import twoPointersProblems from './ExampleProblems/TwoPointersExamples';
import fastAndSlowPointersProblems from './ExampleProblems/FastAndSlowExamples';
import mergeIntervalsProblems from './ExampleProblems/MergeIntervalsExamples';
import cyclicSortProblems from './ExampleProblems/CyclicSortExamples';
import LLReversalProblems from './ExampleProblems/LlReversalExamples';
import bfsProblems from './ExampleProblems/BfsExamples';
import inorderTraversalProblems from './ExampleProblems/InorderTravExamples';
import preorderTraversalProblems from './ExampleProblems/PreorderTravExamples';
import postorderTraversalProblems from './ExampleProblems/PostorderTravExamples';
import topKElementsProblems from './ExampleProblems/TopKElementsExamples';
import kWayMergeProblems from './ExampleProblems/KWayMergeExamples';
import backtrackingProblems from './ExampleProblems/BacktrackingExamples';
import bitManipulaionProblems from './ExampleProblems/BitManipulationExamples';
import oneDimensionalDPProblems from './ExampleProblems/OneDDPExamples';
import twoDimensionalDPProblems from './ExampleProblems/TwoDDPExamples';
import greedyAlgorithmsProblems from './ExampleProblems/GreedyAlgorithmsExamples';
import binarySearchProblems from './ExampleProblems/BinarySearchExamples';


const exampleProblems = {
  "Sliding Window": slidingWindowProblems,
  "Two Pointers": twoPointersProblems,
  "Fast & Slow Pointers": fastAndSlowPointersProblems,
  "Merge Intervals": mergeIntervalsProblems,
  "Cyclic Sort": cyclicSortProblems,
  "In-place Reversal of a Linked List": LLReversalProblems,
  "Breadth-First Search (BFS)": bfsProblems,
  "Inorder Traversal (DFS)": inorderTraversalProblems,
  "Preorder Traversal (DFS)": preorderTraversalProblems,
  "Postorder Traversal (DFS)": postorderTraversalProblems,
  "Top K Elements (Heap)": topKElementsProblems,
  "K-way Merge": kWayMergeProblems,
  "Subsets (Backtracking)": backtrackingProblems,
  "Bit Manipulation": bitManipulaionProblems,
  "1-Dimension DP": oneDimensionalDPProblems,
  "2-Dimension DP": twoDimensionalDPProblems,
  "Greedy Algorithms": greedyAlgorithmsProblems,
  "Binary Search": binarySearchProblems
};

export default exampleProblems;